import React, { useState, useEffect } from 'react';
import './ArtCulture.css';

import Header from '../components/header';
import Footer from '../components/footer';

// Image Imports matching project standard
import artBanner from '../Asets/artbanner.jpg';
import artLogo from '../Asets/artlogo.jpeg'; // Replaced artist profile picture with logo
import art1 from '../Asets/art1.jpeg';
import art2 from '../Asets/art2.jpeg';
import art3 from '../Asets/art3.jpeg';
import art4 from '../Asets/art4.jpeg';
import art5 from '../Asets/art5.jpeg';
import art6 from '../Asets/art6.jpeg';
import art7 from '../Asets/art7.jpeg';
import art8 from '../Asets/art8.jpeg';
import art9 from '../Asets/art9.jpeg';
import art10 from '../Asets/art10.jpeg';
import art11 from '../Asets/art11.jpeg';
import art12 from '../Asets/art12.jpeg';
import art13 from '../Asets/art13.jpeg';
import art14 from '../Asets/art14.jpeg';
import art15 from '../Asets/art15.jpeg';
import art16 from '../Asets/art16.jpeg';
import art17 from '../Asets/art17.jpeg';
import art18 from '../Asets/art18.jpeg';
import art19 from '../Asets/art19.jpeg';

const ArtCulture = () => {
  const [selectedArt, setSelectedArt] = useState(null);

  useEffect(() => {
    const sections = document.querySelectorAll('.fade-in-section');
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // Once visible, stop observing to prevent reload glitches
            observer.unobserve(entry.target);
          }
        });
      },
      { 
        threshold: 0.05, // Slightly lower threshold for faster mobile triggers
        rootMargin: '0px 0px -20px 0px' 
      }
    );
    
    sections.forEach((section) => observer.observe(section));
    
    // Safety check for mobile viewports to reveal components if observer misses them on instant load
    const timeoutId = setTimeout(() => {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top < window.innerHeight) {
          section.classList.add('is-visible');
        }
      });
    }, 400);

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      clearTimeout(timeoutId);
    };
  }, []);

  // Comprehensive array mapping all 19 artworks cleanly
  const galleryItems = [
    { id: 1, img: art1, title: 'The Boundless Soul', category: 'Watercolour & Thread Series' },
    { id: 2, img: art2, title: 'Whispers of Peace', category: 'Mixed Media Canvas' },
    { id: 3, img: art3, title: 'Connections of Grace', category: 'Fine Art Graphite Sketch' },
    { id: 4, img: art4, title: 'The Practical Path', category: 'Watercolour Study' },
    { id: 5, img: art5, title: 'Echoes of Heritage', category: 'Ink Realism Illustration' },
    { id: 6, img: art6, title: 'Roots of Nature', category: 'Acrylic Expression' },
    { id: 7, img: art7, title: 'Unspoken Bond', category: 'Fine Art Sketch' },
    { id: 8, img: art8, title: 'The Cage Within', category: 'Mixed Media Concept' },
    { id: 9, img: art9, title: 'The Heritage Banyan', category: 'Landscape Acrylic' },
    { id: 10, img: art10, title: 'Gateway of Dreams', category: 'Oil Composition' },
    { id: 11, img: art11, title: 'Forest Pathway', category: 'Fine Charcoal Study' },
    { id: 12, img: art12, title: 'The Royal Court', category: 'Architectural Expression' },
    { id: 13, img: art13, title: 'Autumn Lakeshore', category: 'Impressionist Landscape' },
    { id: 14, img: art14, title: 'Portrait of Vision', category: 'Stipple Ink Portrait' },
    { id: 15, img: art15, title: 'Desert Voyager', category: 'Line Art Realism' },
    { id: 16, img: art16, title: 'The Sacred Camel', category: 'Detailed Ink Texturing' },
    { id: 17, img: art17, title: 'Expressions of Life', category: 'Graphite Realism Portrait' },
    { id: 18, img: art18, title: 'Cosmic Flutist', category: 'Traditional Ink & Wash' },
    { id: 19, img: art19, title: 'Dual Pathways', category: 'Miniature Acrylic Landscape' }
  ];

  return (
    <>
      <Header/>
      <div className="art-culture-container">
        {/* 1. HERO BANNER */}
        <section className="art-hero">
          <div className="hero-bg-wrapper">
            <img src={artBanner} alt="Art and Culture Banner" className="hero-bg" />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content">
            <span className="hero-subtitle">EXPRESSION • HONESTY • SOUL</span>
            <h1 className="hero-title">Art & Cultural Legacy</h1>
            <div className="hero-accent-bar"></div>
          </div>
        </section>

        {/* 2. INTRODUCTION */}
        <section className="art-intro fade-in-section">
          <div className="section-bounds">
            <div className="intro-grid">
              <div className="intro-title-area">
                <span className="section-tag">The Philosophy</span>
                <h2>Reconnecting with the True Self</h2>
              </div>
              <div className="intro-text-area">
                <p>
                  In a modern world increasingly dictated by superficial frameworks and systemic routines, art stands as the ultimate, unfiltered mirror. It is not merely an aesthetic arrangement, but a deep psychological inquiry into what makes our practical souls seek peace, rest, and authentic expression.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 3. ARTIST PROFILE (Now features Studio Logo instead of Photo) */}
        <section className="artist-profile fade-in-section">
          <div className="section-bounds">
            <div className="profile-grid">
              <div className="profile-img-container logo-container">
                <img src={artLogo} alt="Art Studio Logo" className="artist-avatar studio-logo" />
                <div className="frame-border"></div>
              </div>
              <div className="profile-bio">
                <span className="section-tag">Meet The Artist</span>
                <h2 className="artist-name">Chetan Salunke</h2>
                <p className="artist-origin">Born in Nashik (1999) • Cultivated & Practicing in Baroda</p>
                
                <div className="bio-paragraph">
                  <p>
                    "In today's world, most people are living an artificial life building relationships and connections only for personal gain. But what about the real part of us—the practical soul within that is still searching for peace, food, sleep, and a simple, meaningful life?"
                  </p>
                  <p>
                    "Through my journey and experiences so far, I've felt these emotions deeply. I try to express them in my art, not just from my own feelings but also by understanding others. I don't consider myself a great artist, not even just an artist. I am a student, and I will always remain one."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. FEATURED GALLERY */}
        <section id="gallery" className="art-gallery fade-in-section">
          <div className="section-bounds">
            <div className="gallery-header">
              <div>
                <span className="section-tag">Curated Portfolio</span>
                <h2>Creative Exhibition Gallery</h2>
              </div>
              <p className="gallery-summary">Click on any piece to open the interactive studio viewer and explore the detailed compositions.</p>
            </div>

            <div className="gallery-grid">
              {galleryItems.map((item) => (
                <div key={item.id} className="gallery-card" onClick={() => setSelectedArt(item)}>
                  <div className="card-img-wrapper">
                    <img src={item.img} alt={item.title} className="gallery-img" loading="lazy" />
                    <div className="card-hover-overlay">
                      <span className="view-details">Expand Canvas</span>
                    </div>
                  </div>
                  <div className="card-info">
                    <h3>{item.title}</h3>
                    <p>{item.category}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. VISION & PHILOSOPHY */}
        <section className="art-vision fade-in-section">
          <div className="section-bounds">
            <div className="vision-card">
              <div className="vision-content">
                <span className="section-tag">Artistic Manifest</span>
                <h2>"Inspired by nature, trying to express, explore, and live my art journey with honesty."</h2>
                <p className="vision-author">— Chetan Salunke</p>
              </div>
            </div>
          </div>
        </section>

        {/* 6. CULTURAL HERITAGE & INSPIRATIONS */}
        <section className="cultural-heritage fade-in-section">
          <div className="section-bounds">
            <div className="heritage-grid">
              <div className="heritage-block">
                <span className="block-num">01</span>
                <h3>Baroda's Living Core</h3>
                <p>Drawing massive conceptual weight from the architectural, cultural, and fine art academic history of Baroda, the works inherently possess a legacy-driven grounding.</p>
              </div>
              <div className="heritage-block">
                <span className="block-num">02</span>
                <h3>Human Emotion Spectrum</h3>
                <p>Laughing, crying, loving, heartbreak, and responsibilities. Converting universal, everyday human friction into subtle textures and continuous lines.</p>
              </div>
              <div className="heritage-block">
                <span className="block-num">03</span>
                <h3>Raw Organic Mediums</h3>
                <p>Using precise realism blended with minimalist negative space to let the paper breathe, inviting onlookers to complete the story themselves.</p>
              </div>
            </div>
          </div>
        </section>

        {/* 7. ACHIEVEMENTS & EXHIBITIONS */}
        <section className="art-exhibitions fade-in-section">
          <div className="section-bounds">
            <span className="section-tag">Milestones</span>
            <h2 className="section-title-center">Exhibitions & Recognition</h2>
            
            <div className="timeline">
              <div className="timeline-item">
                <span className="timeline-year">2026</span>
                <div className="timeline-detail">
                  <h3>Contemporary Realism Exposition</h3>
                  <p>Featured master studies and emotional portraits in a curated regional group showing.</p>
                </div>
              </div>
              <div className="timeline-item">
                <span className="timeline-year">2025</span>
                <div className="timeline-detail">
                  <h3>The 'Practical Soul' Solo Series</h3>
                  <p>An experimental exhibition focusing entirely on human relationships and connection dynamics in modern cities.</p>
                </div>
              </div>
              <div className="timeline-item">
                <span className="timeline-year">2023</span>
                <div className="timeline-detail">
                  <h3>Baroda Fine Art Annual Meet</h3>
                  <p>Awarded promising student presentation for intricate mixed-media storytelling works.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 8. TESTIMONIALS */}
        <section className="art-testimonials fade-in-section">
          <div className="section-bounds">
            <span className="section-tag">Appreciation</span>
            <h2 className="section-title-center">Collector Perspectives</h2>
            
            <div className="testimonials-grid">
              <div className="testimonial-box">
                <p className="quote">"Salunke’s work brings a startling clarity to everyday objects and figures. There is an emotional weight behind each composition that demands silence and reflection."</p>
                <h4 className="author-name">Modern Art Review</h4>
              </div>
              <div className="testimonial-box">
                <p className="quote">"Owning a custom canvas from the emotional series felt less like purchasing decoration and more like capturing an authentic fragment of human psychology."</p>
                <h4 className="author-name">Private Collector, Mumbai</h4>
              </div>
            </div>
          </div>
        </section>

        {/* 9. CALL TO ACTION */}
        <section className="art-cta fade-in-section">
          <div className="cta-content">
            <h2>Acquire or Commission Artwork</h2>
            <p>Bring authentic, emotionally rich visual storytelling to your private collection or gallery space. Open for collaborative exhibitions and commissioned concepts.</p>
            <div className="cta-btn-group">
              <button className="btn-premium">Inquire About Pieces</button>
              <button className="btn-secondary">Request Catalog</button>
            </div>
          </div>
        </section>

        <br />

        {/* INTERACTIVE LIGHTBOX MODAL DIALOG */}
        {selectedArt && (
          <div className="art-modal-overlay" onClick={() => setSelectedArt(null)}>
            <div className="art-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="art-modal-close" onClick={() => setSelectedArt(null)} aria-label="Close modal">
                &times;
              </button>
              <div className="art-modal-grid">
                <div className="art-modal-image-panel">
                  <img src={selectedArt.img} alt={selectedArt.title} />
                </div>
                <div className="art-modal-info-panel">
                  <span className="modal-tag">Fine Art Showcase</span>
                  <h2>{selectedArt.title}</h2>
                  <div className="modal-divider"></div>
                  <p className="modal-category"><strong>Medium / Category:</strong> {selectedArt.category}</p>
                  <p className="modal-description">
                    An authentic hand-crafted rendering exploring regional roots, nature, and the continuous journey of emotional realism by artist Chetan Salunke.
                  </p>
                  <button className="btn-premium modal-cta-btn" onClick={() => setSelectedArt(null)}>
                    Return To Gallery
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer/>
    </>
  );
};

export default ArtCulture;